import { G_VIEW__column_center_image_edit } from './G_VIEW__column_center_image_edit';

interface PROPS {
  children: React.ReactNode;
}

export function G_LAYOUT__image_edit_base({ children }: PROPS) {
  /*
   * STATE
   */

  /*
   * HTML
   */

  return (
    <div className="info__layout_image_edit relative size-full flex-center p-1 bg-component">
      {children}
      <G_VIEW__column_center_image_edit />
    </div>
  );
}
